export default __webpack_public_path__ + "static/media/hp.d6c7036b.png";